import { render, staticRenderFns } from "./MainC.vue?vue&type=template&id=3dd289ee&scoped=true&"
import script from "./MainC.vue?vue&type=script&lang=ts&"
export * from "./MainC.vue?vue&type=script&lang=ts&"
import style0 from "./MainC.vue?vue&type=style&index=0&id=3dd289ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd289ee",
  null
  
)

export default component.exports